module.exports = __webpack_public_path__ + "static/media/concept3.d57c5809.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/Twitch/Concepts/img/concept3.mp4
// module id = 248
// module chunks = 0